import axios from "@/axios";

export default {
    list(payload) {
        return axios.get('coworkings', payload);
    },
    item(id) {
        return axios.get(`coworkings/${id}`);
    },
    review: {
        list(id, page) {
            return axios.get(`coworkings/${id}/reviews?page=${page}`);
        },
        create(id, payload) {
            return axios.post(`coworkings/${id}/reviews`, payload);
        },
    },
    zone: {
        list(coworking) {
            return axios.get(`coworkings/${coworking}/zones`);
        },
        tariff: {
            list(coworking) {
                return axios.get(`coworkings/${coworking}/zones/tariffs`);
            },
            item(coworking, tariff) {
                return axios.get(`coworkings/${coworking}/zones/tariffs/${tariff}`);
            }
        },
        image: {
            list(coworking) {
                return axios.get(`coworkings/${coworking}/zones/images`);
            },
        },
        workplace: {
            available(coworking, zone, payload) {
                return axios.get(`coworkings/${coworking}/zones/${zone}/workplaces/available`, payload);
            },
            list(coworking, zone, payload) {
                return axios.get(`coworkings/${coworking}/zones/${zone}/workplaces`, payload);
            },
        },
    },
}